var exports = {
  "kL": "ChannelStickersArea.module__container___OFB4az",
  "gI": "ChannelStickersArea.module__standalone___OFB4az",
  "Qs": "ChannelStickersArea.module__content___OFB4az",
  "UV": "ChannelStickersArea.module__stickerPreview___OFB4az",
  "HF": "ChannelStickersArea.module__stickerImage___OFB4az",
  "od": "ChannelStickersArea.module__stickerInfo___OFB4az",
  "Zl": "ChannelStickersArea.module__stickerName___OFB4az",
  "Gl": "ChannelStickersArea.module__stickerDescription___OFB4az",
  "DT": "ChannelStickersArea.module__removeButton___OFB4az",
  "Kk": "ChannelStickersArea.module__icon___OFB4az",
};

module.exports = exports;
